import USA from '../assets/images/usa.svg'
import Colombia from '../assets/images/colombia.svg'
export const GENERIC_REQUEST_ERROR = 'Something went wrong. Please try again later'

// Survey Question Display Options
export const QuestionDisplayOptions = {
  GRID_LAYOUT: 'GRID_LAYOUT',
  DROPDOWN: 'DROPDOWN',
  LIST_HORIZONTAL: 'LIST_HORIZONTAL',
  LIST_VERTICAL: 'LIST_VERTICAL',
  OPEN_TEXT: 'OPEN_TEXT',
  DATE: 'DATE',
  NONE: 'NONE',
} as const
export const CURRENCY_ITEMS = {
  USD: {
    label: 'USD',
    symbol: '$',
    decimalSeparator: '.',
    groupSeparator: ',',
    img: USA,
  },
  COP: {
    label: 'COP',
    symbol: 'COP',
    decimalSeparator: ',',
    groupSeparator: '.',
    img: Colombia,
  },
}

/** MINCIT PMS page where hosts sign in to get their TRA API token. */
export const TRA_TOKEN_URL = 'https://pms.mincit.gov.co/token/'
